/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * jAIn checks CONFIGURATION, TOKEN, JAIN; the media store CONFIGURATION, WRITE, LINK, DELETE.
 * @export
 * @enum {string}
 */

export const CheckStepNameDto = {
    Configuration: 'CONFIGURATION',
    Token: 'TOKEN',
    Jain: 'JAIN',
    Write: 'WRITE',
    Link: 'LINK',
    Delete: 'DELETE'
} as const;

export type CheckStepNameDto = typeof CheckStepNameDto[keyof typeof CheckStepNameDto];



